<template>
	<nav class="search-page mt-4 mb-4" aria-label="Pagination" v-show="totalPages">
		<ul class="pagination lead justify-content-center align-items-center ">
			<li class="page-item">
				<a class="page-link search-page__link search-page__link--icon border-0 bg-transparent " href="#" @click="click($event, currentPage - 1)" :class="{ 'disabled': disablePrev }">
					<span class="fe fe-chevron-left" aria-hidden="true"></span>
					<span class="sr-only">Previous</span>
				</a>
			</li>
			<li v-for="(item, idx) in items" :key="idx" class="page-item">
				<a class="page-link border-0 bg-transparent text-secondary" :class="{ 'active': item.active, 'disabled': !item.index }" href="#" @click="click($event, item.index)">
					<span v-html="item.label"></span>
				</a>
			</li>
			<li class="page-item">
				<a class="page-link search-page__link search-page__link--icon border-0 bg-transparent" href="#" @click="click($event, currentPage + 1)" :class="{ 'disabled': disableNext }">
					<span class="fe fe-chevron-right" aria-hidden="true"></span>
					<span class="sr-only">Next</span>
				</a>
			</li>
		</ul>
	</nav>
</template>

<script>
export default {
	name: 'Pagination',
	props: {
		currentPage: {
			type: Number,
			default: 1
		},
		totalPages: {
			type: Number,
			default: 10
		},
		size: {
			type: String,
			default: "large" // small
		}
	},
	computed: {
		disablePrev () {
			return (this.currentPage == 1);
		},
		disableNext () {
			return (this.currentPage == this.totalPages);
		},
		nbItems () {
			return ( this.size === 'large' ? 9 : 7 )
		},
		nbDots () {
			return this.totalPages > 10 ? ( this.size === 'large' ? 4 : 2 ) : 0
		},
		items() {

			let pagesStart, pagesEnd, nbDotsBefore, nbDotsAfter = 0;

			if ( this.totalPages < this.nbItems + 2 ) {
				pagesStart = 2;
				pagesEnd = this.totalPages - 1;
				nbDotsBefore = 0;
				nbDotsAfter = 0;
			}
			else {
				pagesStart = Math.max( 2, this.currentPage - 2 );
				pagesEnd = Math.min( this.totalPages - 1, pagesStart + this.nbItems - this.nbDots - 1);
				pagesStart = pagesEnd - 4; // Adjust page start to be sure the number of pages are equal to 4

				// Calculate the number of dots in the begining
				nbDotsBefore = 0;
				if ( 	this.currentPage > 5 ) {
					if ( (this.totalPages - this.currentPage) < 4 ) nbDotsBefore = 4
					else if ( (this.totalPages - this.currentPage) < 5 ) nbDotsBefore = 3
					else nbDotsBefore = 2
				}
				else if (this.currentPage > 4) nbDotsBefore = 1

				// The number of dots at the ends are the one left from the begining
				nbDotsAfter = this.nbDots - nbDotsBefore;
			}



			const items = [];
			// Add first
			items.push({
				index: 1,
				label: 1,
				active: (1 === this.currentPage)
			});
			// Dots
			for (let i = 0; i < nbDotsBefore; i++) {
				items.push({ index: false, label: "&#8226;", active: false });
			}
			// Items
			for (let i = pagesStart; i <= pagesEnd; i++) {
				items.push({
					index: i,
					label: i,
					active: (i === this.currentPage)
				});
			}
			// Dots
			for (let i = 0; i < nbDotsAfter; i++) {
				items.push({ index: false, label: "&#8226;", active: false });
			}
			// Add last
			if ( this.totalPages > 1 ) {
				items.push({
					index: this.totalPages,
					label: this.totalPages,
					active: (this.totalPages === this.currentPage)
				});
			}

			return items;
		}
	},
	methods: {
		click(event, page) {
			event.preventDefault();
			if(page <= 1) {
				this.leftDisabled = true;
			}
			else if (page >= this.totalPages) {
				this.rightDisabled = true;
			}
			else {
				this.leftDisabled = false;
				this.rightDisabled = false;
			}
			this.$emit('change', page);
		}
	}
}
</script>

<style lang="scss" scoped>
.page-link {
	&.active {
		color: black !important;
		font-weight: bold;

		span {
			position: relative;
		}

		span::after {
			display: block;
			position: absolute;
			content: "";
			width: 135%;
			height: 4px;
			background: black;
			margin-top: 3px;
			left: 50%;
			transform: translateX(-50%);
		}

		.page-link span::after {
			display: block;
			position: absolute;
			content: "";
			width: 18px;
			height: 4px;
			bottom: -1px;
			left: 10px;
			background: black;
		}
	}
}

/*
 * STATES
 */

.disabled {
	pointer-events: none;
	opacity: .4;
}
</style>
